import { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { RolesAndPermissionsContext } from 'context/RolesAndPermissionsContext';

import Tooltip from 'components/tooltip';

import IconEye from 'icons/icon-eye';

const HiddenFrom = ({ value, type }) => {
    const { t } = useTranslation(['task', 'milestone']);
    const rolesAndPermissions = useContext(RolesAndPermissionsContext);

    const i18nString = useMemo(() => {
        switch (type) {
            case 'task':
                return 'task:Task hidden from';

            case 'task_group':
                return 'task:Status hidden from';

            case 'milestone':
                return 'milestone:Milestone hidden from';

            default:
                return '';
        }
    }, [type]);

    if (!value?.length) {
        return null;
    }

    return (
        <Tooltip tooltip={ t(i18nString, { roles: rolesAndPermissions?.getRolesListString(value, true) }) }>
            <div className="meta-item with-tooltip">
                <span className="meta-icon meta-icon-single">
                    <IconEye />
                </span>
            </div>
        </Tooltip>
    );
}

export default HiddenFrom;
